import { connect } from 'react-redux';
import EligibilityAgentView from './EligibilityAgentView';
import * as eligibilityActions from '../../../redux/actions/eligibility.actions';
import { validateMultiEligibility } from '../../../parsers/eligibility.parser';
import { createWandAttemptId } from '../../../utils/wandAttempt';

const mapStateToProps = state => {
  const validationReasons = validateMultiEligibility(state);

  return {
    isOpen: state.eligibility.agentView.isOpen,
    isLoading: state.eligibility.agentView.isLoading,
    changes: state.eligibility.agentView.changes,
    issues: state.eligibility.agentView.issues,
    coverages: state.eligibility.agentView.coverages,
    coordinationTypes: state.infobox.coordinationTypes,
    infoboxCoverages: state.infobox.coverages,
    summary: state.eligibility.agentView.summary,
    changesStatus: state.eligibility.agentView.changesStatus,
    changesAccepted: state.eligibility.agentView.changesAccepted,
    changesRejected: state.eligibility.agentView.changesRejected,
    isBillerVerified: state.eligibility.agentView.isBillerVerified,
    verifiedAt: state.eligibility.agentView.verifiedAt,
    pendingReview: state.eligibility.agentView.pendingReview,
    rerunDisabled: validationReasons.length > 0,
    rerunTooltip: validationReasons.join(' '),
  };
};

const mapDispatchToProps = dispatch => ({
  onAccept: () => dispatch(eligibilityActions.acceptMultiChanges()),
  onReject: rejectReason => dispatch(eligibilityActions.rejectMultiChanges({ rejectReason })),
  onClose: () => dispatch(eligibilityActions.hideEligibilityView()),
  onRerun: () => dispatch(eligibilityActions.checkMultiEligibility({ wandAttemptId: createWandAttemptId() })),
});

export default connect(mapStateToProps, mapDispatchToProps)(EligibilityAgentView);
